module.exports = __webpack_public_path__ + "static/media/logo_hkstp_color.e79ca530.svg";